import { Col } from 'reactstrap';
import copy from 'copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

const InstanceId = () => {
    const instanceId = useSelector(state => state.practice.practice?.instanceId  ?? '');
    const clickInstanceId = () => {
        copy(instanceId?.toUpperCase());
        var elem = document.getElementById(`instanceText`);
        elem.innerHTML = '&emsp;Copied!';
        setTimeout(() => {
            elem.innerHTML = '';
        }, 1000);
    };
    return (
        <Col md={12}
            className='hoverable d-flex px-3 py-2'
            onClick={clickInstanceId}
            title="Instance ID">
            <span className="underline-on-hover">
                <FontAwesomeIcon
                    className="text-light op-6"
                    icon={faFingerprint}
                    size="lg"
                />
                &emsp;
                {instanceId?.toUpperCase()}
            </span>
            <span id="instanceText" className="text-light op-8"></span>
        </Col>
    );
};

export default InstanceId;
